export class RegexConfigModel {
  fieldName = '';
  minLength = 0;
  maxLength = 0;
  pattern = '';
  errorMessage = '';
  server = '';
  required?: boolean = false;
}
